import React, {Component} from "react";
import {APIClient} from "../../utils/APIClient";
import {API_URL} from "../../settings/local_settings";
import {ClientHeader} from "./ClientHeader";
import {ClientTabs} from "./ClientTabs";
import {ClientPortalTab} from "./ClientPortalTab";
import { withTranslation } from 'react-i18next';

class ClientPortalTabContentClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
        };
    }

    componentDidMount() {
        this.getClientData();
    }

    getClientData() {
        new APIClient(API_URL + 'client/' + this.props.clientId).call('GET').then((data) => {
            if (data.status === 'OK') {
                this.setState({name: data.data['name']});
            }
        });
    }

    render() {
        return (
            <section className="section-content">
                <ClientHeader name={this.state.name}/>
                <ClientTabs clientId={this.props.clientId}/>
                <ClientPortalTab clientId={this.props.clientId} clientName={this.state.name}/>
            </section>
        );
    }
}

export const ClientPortalTabContent = withTranslation()(ClientPortalTabContentClass);
